import React from 'react'

const Alumni_Association = () => {
  return (
    <div>
      <h1 className='py-5 text-center'>Alumni Association</h1>
    </div>
  )
}

export default Alumni_Association
